
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health/intro",
      function () {
        return require("private-next-pages/health/intro.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health/intro"])
      });
    }
  